$(function () {

    $(document).ready(function () {

        var heroCarousel = $('.ze-hero-carousel .hero-carousel');

        if (heroCarousel.length > 0) {
            heroCarousel.each(function () {
                var carousel = $(this);

                carousel.owlCarousel({
                    items: 1,
                    margin: 0,
                    loop: true,
                    autoplayTimeout: parseInt(carousel.data('auto-scroll-speed')),
                    autoplay: true,
                    dots: true,
                    smartSpeed: 900,
                    lazyLoad: true
                });
            });
        }
    });

});